import { Route, RouteComponentProps, Switch } from "react-router-dom";
import { NotFound } from "@app/shared/ErrorPages";
import BulkSharing from "./BulkSharing";
import { JSX } from "react";

/** Renders the routing components for the resources sub-section of the app. */
export default function ResourcesRouter(props: RouteComponentProps): JSX.Element {
  return (
    <Switch>
      <Route path={`${props.match.path}/share`} component={BulkSharing} />
      <Route component={NotFound} />
    </Switch>
  );
}
